export default "__VITE_ASSET__BxoocmOw__"